// extracted by mini-css-extract-plugin
export default {"BlogPostPage":"styles_BlogPostPage__GSWn5","container":"styles_container__vtTAV","content":"styles_content__QaaFN","textContent":"styles_textContent__LOYKw"};